import { render } from "./NBAThoughtTrace.vue?vue&type=template&id=69858a92&scoped=true"
import script from "./NBAThoughtTrace.vue?vue&type=script&lang=js"
export * from "./NBAThoughtTrace.vue?vue&type=script&lang=js"

import "./NBAThoughtTrace.vue?vue&type=style&index=0&id=69858a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69858a92"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinnerDots});
